<script>
  /**
   * This is a simple wrapper, covering one input field. In order to render
   * each one nicely this should be qualified with one of the these flags
   * specifying its purpose.
   *
   * The input field in question is rendered by <slot/>.
   */
  export let required = false;
  export let checkbox = false;
  export let radiobuttons = false;
  export let style = '';
</script>

<div
  class="formfield"
  class:flyinglabel={!checkbox && !radiobuttons}
  class:required
  class:checkbox
  class:radiobuttons
  {style}
>
  <slot />
</div>
